import type { ListColor } from './ListColor.types';

export const DEFAULT_LIST_COLOR: ListColor = 'gray';
